<template>
    <div class="dd-rule-map-wrapper">
        <div v-for="{ ruleMapValue, ruleMapKey, counter} in rulesMapArray" :key="ruleMapValue.id">
            <div class="row-wrapper">
                <DecisionDiamondRule
                    :rule-map-key="ruleMapKey"
                    :rule-map-value="ruleMapValue"
                    :comparison="comparison"
                    :first-rule="counter === 0"
                    :dd-keys="ddKeys"
                    class="decision-diamond-rule"
                    @add-rule-value-global="addRuleValueGlobal"
                />

                <div class="action-icons">
                    <span class="copy-icon" @click="duplicateRow(ruleMapKey, ruleMapValue.ruleGroupId)">
                        <DsIcon name="copy" />
                    </span>
                    <span class="remove-icon" @click="removeRow(ruleMapKey)">
                        <DsIcon name="trash-2" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DecisionDiamondRule from './DecisionDiamondRule.vue';

export default {
    name: 'DecisionDiamondRuleValues',
    components: {
        DecisionDiamondRule,
    },
    props: {
        rulesMap: {
            type: Object,
            required: true,
        },
        comparison: {
            type: String,
            required: true,
        },
        ddKeys: {
            type: Object,
            required: true,
        },
    },
    emits: ['duplicate-row', 'remove-rule', 'add-rule-value-global'],
    computed: {
        rulesMapArray() {
            return Object.keys(this.rulesMap || []).map((key, index) => {
                const value = this.rulesMap[key];

                return { counter: index, ruleMapKey: key, ruleMapValue: value };
            });
        },
    },
    methods: {
        duplicateRow(ruleMapKey, ruleGroupInnerId) {
            this.$emit('duplicate-row', ruleMapKey, ruleGroupInnerId);
        },
        removeRow(ruleId) {
            this.$emit('remove-rule', ruleId);
        },
        addRuleValueGlobal(ruleMapKey, rule) {
            this.$emit('add-rule-value-global', ruleMapKey, rule);
        },
    },
};
</script>


<style lang="scss" scoped>
.dd-rule-map-wrapper {
    margin-top: $spacing-250;
    margin-left: $spacing-250;
}

.row-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    width: 100%;
}

.decision-diamond-rule {
    width: 90%;
}

.action-icons {
    display: flex;
    flex-direction: row;
    float: right;
    padding-right: $spacing-300;
}

.copy-icon,
.remove-icon {
    margin-right: $spacing-125;
    cursor: pointer;
}

.copy-icon:last-child,
.remove-icon:last-child {
    margin-right: 0;
}

</style>
